import { defineMessages } from 'react-intl';

const messages: {
	actionMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confirmButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	actionCardTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	actionMessage: {
		id: 'ai-mate.message-actions.confluence-aifc-adf-update.action-message',
		defaultMessage:
			"Here's a summary of the suggested changes. Review them, then select <bold>Confirm</bold> when you're ready.",
		description:
			'Message text displayed in an action card within the AI conversation interface when the AI proposes edits to a Confluence page. Shown as the main message text in the action card body. The <bold> tags will be rendered as bold text for "Confirm". The purpose is to present the AI-proposed changes to the user for review and provide clear instructions on how to proceed with applying the changes.',
	},
	confirmButton: {
		id: 'ai-mate.message-actions.confluence-aifc-adf-update.confirm-button',
		defaultMessage: 'Confirm',
		description:
			'Button label displayed on the primary action button in the Confluence ADF update action card within the AI conversation interface. When clicked, it confirms and applies the proposed content changes to the Confluence page.',
	},
	cancelButton: {
		id: 'ai-mate.message-actions.confluence-aifc-adf-update.cancel-button',
		defaultMessage: 'Cancel',
		description:
			'Button label displayed on the secondary action button in the Confluence ADF update action card within the AI conversation interface. When clicked, it cancels the proposed content changes.',
	},
	actionCardTitle: {
		id: 'ai-mate.message-actions.confluence-aifc-adf-update.action-card-title',
		defaultMessage: 'Edit content',
		description:
			'Title text displayed at the top of an action card in the AI conversation interface when the AI proposes editing a Confluence page. Shown as the card header title.',
	},
});
export default messages;
